import { Vector3 } from "three";
import { getPositionsFromObject3D } from "./Utils.js";
export function line_line_2D(a1, a2, b1, b2, target) {
    const [_a1, _a2, _b1, _b2, _target] = getPositionsFromObject3D([a1, a2, b1, b2, target]);
    const denominator = (_b2.y - _b1.y) * (_a2.x - _a1.x) - (_b2.x - _b1.x) * (_a2.y - _a1.y);
    if (denominator === 0)
        return null; // parallel
    const ua = ((_b2.x - _b1.x) * (_a1.y - _b1.y) - (_b2.y - _b1.y) * (_a1.x - _b1.x)) / denominator;
    return _target.set(_a1.x + ua * (_a2.x - _a1.x), _a1.y + ua * (_a2.y - _a1.y), 0);
}
/**
 * Calcola l'intersezione tra un'ellisse ruotata e un segmento dal centro.
 * @param center Centro dell'ellisse
 * @param a Lunghezza del semi-asse orizzontale (prima della rotazione)
 * @param b Lunghezza del semi-asse verticale (prima della rotazione)
 * @param rotation Angolo di rotazione in radianti (senso orario)
 * @param targetPoint Punto verso cui punta il segmento
 */
export function getEllipseIntersectionWithRotation(center, a, b, rotation, targetPoint) {
    // 1. Vettore relativo dal centro al target
    const dx = targetPoint.x - center.x;
    const dy = targetPoint.y - center.y;
    if (dx === 0 && dy === 0)
        return null;
    // 2. Ruotiamo il vettore target nello spazio locale dell'ellisse
    // Usiamo l'angolo negativo per "annullare" la rotazione dell'ellisse
    const cosR = Math.cos(-rotation);
    const sinR = Math.sin(-rotation);
    const localDx = dx * cosR - dy * sinR;
    const localDy = dx * sinR + dy * cosR;
    // 3. Calcolo intersezione nello spazio locale (ellisse dritta nell'origine)
    const a2 = a * a;
    const b2 = b * b;
    const ldx2 = localDx * localDx;
    const ldy2 = localDy * localDy;
    const denominator = Math.sqrt(b2 * ldx2 + a2 * ldy2);
    const localIx = (a * b * localDx) / denominator;
    const localIy = (a * b * localDy) / denominator;
    // 4. Riportiamo il punto di intersezione nello spazio globale
    // Ruotiamo di nuovo dell'angolo originale e trasliamo al centro
    const cosOrig = Math.cos(rotation);
    const sinOrig = Math.sin(rotation);
    return new Vector3(center.x + (localIx * cosOrig - localIy * sinOrig), center.y + (localIx * sinOrig + localIy * cosOrig), center.z);
}
//# sourceMappingURL=IntersectionUtils.js.map